/**
 * TODO: these should be removed and deferred to mui customization set in te-components
 * Do not remove default breakpoints since they are used by
 * material-UI components.
 * https://material-ui.com/customization/breakpoints/#custom-breakpoints
 */
const breakpoints = {
  values: {
    // Default breakpoints
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
};

export const customChipColors = {
  successBackground: '#e5f3ee',
  infoBackground: '#e6edf5',
  stopIcon: '#ebebeb',
  stopIconbackground: '#6c6c6c',
};

const customChartColors = {
  fillColorBlue: '#1976d2',
  fillColorGrey: '#b7b7b788',
  strokeColorRed: '#F00328CC',
  strokeColorWhite: '#fff',
  highlightStrokeGrey: 'rgba(183, 183, 183,.75)',
  primarySelectedBackground: '#EDF2FC',
  fillColorGreen: 'rgba(128,206,157,1)',
  fillColorMint: 'rgba(179,226,196,.6)',
  fillColorSoftGreen: 'rgba(179,226,196,.6)',
  fillColorSkyBlue: 'rgba(146,194,203,.6)',
  strokeColorBlue: 'rgba(82,128,216,1)',
  fillColorSlateGrey: 'rgba(101,101,101,.8)',
  fillColorDarkGrey: 'rgba(0,0,0,.05)',
};

export const customTheme = {
  breakpoints,
  mutedText: {
    color: '#0000008a',
    fontSize: 14,
  },
  typography: {
    subtitle1: {
      fontWeight: 600,
    },
  },
  fontWeight600: 600,
  customChartColors,
};
